import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { DataTable, LayoutGap } from '@gov-nx/ui/web';
import {
	generateArrayFromLength,
	generateRandomNumber,
} from '@gov-nx/utils/common';

export const EPetitionFormSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap gap="m">
			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<div className="flex gap-4 items-center">
					<GovSkeleton
						height="40px"
						width="40px"
						className="py-2"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="28px"
						width="200px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<LayoutGap
					gap="xl"
					className="[ md:pl-16 ]">
					<GovSkeleton
						width="220px"
						height="36px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<div>
						<GovSkeleton
							width="300px"
							height="20px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<GovSkeleton
							width="100%"
							height="40px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<LayoutGap gap="m">
						<GovSkeleton
							width="270px"
							height="36px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<GovSkeleton
							width="70%"
							height="24px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<GovSkeleton
							width="200px"
							height="20px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<div className="flex gap-2">
							<GovSkeleton
								width="24px"
								height="24px"
								shape="circle"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
							<GovSkeleton
								width="120px"
								height="24px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
						</div>
						<DataTable responsive>
							<tbody>
								{generateArrayFromLength(3).map((i) => (
									<tr key={`skeleton-${i}`}>
										<td className="sm:w-1/2!">
											<GovSkeleton
												height="19px"
												width={generateRandomNumber(30, 60) + '%'}
												aria-label={t('loading.wcag.processing', {
													namespace: LocalizeNameSpaceTypes.Global,
												})}
											/>
										</td>
										<td>
											<GovSkeleton
												height="19px"
												width={generateRandomNumber(30, 60) + '%'}
												aria-label={t('loading.wcag.processing', {
													namespace: LocalizeNameSpaceTypes.Global,
												})}
												className="flex grow"
											/>
										</td>
									</tr>
								))}
							</tbody>
						</DataTable>
						<div className="flex gap-2">
							<GovSkeleton
								width="24px"
								height="24px"
								shape="circle"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
							<GovSkeleton
								width="140px"
								height="24px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
						</div>
					</LayoutGap>
					<GovSkeleton
						width="100%"
						height="80px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<div className="flex justify-end">
						<GovSkeleton
							width="170px"
							height="40px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
				</LayoutGap>
			</LayoutGap>

			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<div className="flex gap-4 items-center">
					<GovSkeleton
						height="40px"
						width="40px"
						className="py-2"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="28px"
						width="160px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</LayoutGap>

			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<div className="flex gap-4 items-center">
					<GovSkeleton
						height="40px"
						width="40px"
						className="py-2"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="28px"
						width="100px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</LayoutGap>

			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<div className="flex gap-4 items-center">
					<GovSkeleton
						height="40px"
						width="40px"
						className="py-2"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="28px"
						width="95px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</LayoutGap>
		</LayoutGap>
	);
};
